import { Inject, Injectable } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import {
    DASHBOARD_USERS_REPOSITORY_PORT,
    DashboardUserEntityPort,
    DashboardUsersRepositoryPort,
} from '../ports/dashboard-locale.dependencies';
import { Locale } from '../../domain/entities/locale';

@Injectable({
    providedIn: 'root',
})
export class UpdateUserLocaleUseCase {
    public constructor(
        @Inject(DASHBOARD_USERS_REPOSITORY_PORT)
        private usersRepository: DashboardUsersRepositoryPort,
    ) {}

    public execute(userId: string, locale: Locale): Observable<void> {
        return this.usersRepository.get(userId).pipe(
            switchMap((user: DashboardUserEntityPort) => {
                user.attributes.lang = locale.localeCode.value;

                return user.save();
            }),
            map(() => undefined),
        );
    }
}
